import React from 'react';
import LazyRoute from 'components/lazy-route/index';
import Error from 'templates/error/index';
import RootTemplate from 'templates/root';
import DashboardTemplage from 'templates/dashboard';
import OnboardingTemplate from 'templates/onboarding';
import { STRIPE_JAVASCRIPT_API } from 'constants/stripe';
import loadScript from 'util/dom/load-script';
/* eslint-disable react/display-name */

// template names constants
export const ROOT = 'root';
export const DASHBOARD = 'dashboard';
export const ONBOARDING = 'onboarding';
export const PRODUCTS_OVERVIEW = 'products_overview';
export const PRODUCTS_LIST = 'products_list';
export const DELIVERY_SEARCH = 'delivery_search';
export const CHECKOUT = 'checkout';
export const PROFILE = 'profile';
export const PROFILE_CUMULUS_PRODUCTS = 'profile_cumulus_products';
export const PROFILE_ORDERS = 'profile_orders';
export const PROFILE_ORDERS_DETAIL = 'profile_orders_detail';
export const PRODUCT_DETAIL = 'product_detail';
export const CONTENT_PAGE = 'content_page';
export const CONTENT_PAGE_NO_CONTAINER = 'content_page_no_container';
export const STYLEGUIDE = 'styleguide';
export const TOPICS = 'topics';
export const ERROR_NOT_FOUND = 'error_not_found';

/**
 * Templates data table
 */
const templates = {
    [ROOT]: RootTemplate,
    [DASHBOARD]: DashboardTemplage,
    [ONBOARDING]: OnboardingTemplate,
    [TOPICS]: props => <LazyRoute {...props} component={import(/* webpackChunkName: 'template/products-overview' */'templates/topic-detail')}/>,
    [PRODUCTS_OVERVIEW]: props => <LazyRoute {...props} component={import(/* webpackChunkName: 'template/products-overview' */'templates/products-overview')}/>,
    [PRODUCTS_LIST]: props => <LazyRoute {...props} component={import(/* webpackChunkName: 'template/products-list' */'templates/products-list')}/>,
    [DELIVERY_SEARCH]: props => <LazyRoute {...props} component={import(/* webpackChunkName: 'templates/delivery-search' */'templates/delivery-search')}/>,
    [CHECKOUT]: props => <LazyRoute {...props} component={loadScript(STRIPE_JAVASCRIPT_API).then(() => import(/* webpackChunkName: 'templates/checkout' */'templates/checkout'))}/>,
    [PROFILE]: props => <LazyRoute {...props} component={import(/* webpackChunkName: 'templates/profile' */'templates/profile')}/>,
    [PROFILE_CUMULUS_PRODUCTS]: props => <LazyRoute {...props} component={import(/* webpackChunkName: 'templates/profile-cumulus-products' */'templates/profile-cumulus-products')}/>,
    [PROFILE_ORDERS]: props => <LazyRoute {...props} component={import(/* webpackChunkName: 'templates/profile-orders' */'templates/profile-orders')}/>,
    [PROFILE_ORDERS_DETAIL]: props => <LazyRoute {...props} component={import(/* webpackChunkName: 'templates/profile-orders-detail' */'templates/profile-orders-detail')}/>,
    [PRODUCT_DETAIL]: props => <LazyRoute {...props} component={import(/* webpackChunkName: 'templates/product-detail' */'templates/product-detail')}/>,
    [CONTENT_PAGE]: props => <LazyRoute {...props} component={import(/* webpackChunkName: 'templates/content-page' */'templates/content-page')}/>,
    [CONTENT_PAGE_NO_CONTAINER]: props => <LazyRoute {...props}
        component={import(/* webpackChunkName: 'templates/content-page-no-container' */'templates/content-page-no-container')}/>,
    [STYLEGUIDE]: props => <LazyRoute {...props} component={import(/* webpackChunkName: 'styleguide/page' */'styleguide/page')}/>,
    [ERROR_NOT_FOUND]: props => (
        <Error
            {...props}
            title={'error.not_found_title'}
            subtitle={'error.not_found_subtitle'}
            description={'error.not_found_description'}
        />
    ),
};

/**
 * Get a template by its name
 * @param {string} name - a valid template component
 * @returns {React.Component}
 */
export function get(name) {
    return templates[name];
}

export default templates;



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/templates/index.js